import { CAMPER_TYPES_INTEGER } from '@yescapa-dev/ysc-api-js/modern'

export const useOrderedVehicleOptions = () => {
  const { getReferentialOptions } = useReferentialStore()

  const vehicleOptions = computed(() => {
    const options = getReferentialOptions('vehicle_type_choices').slice()

    // Move van and campervan to respective first and second place
    const getOrderedValue = (v: number) => {
      if (v === CAMPER_TYPES_INTEGER.VAN) {
        return 0
      }
      if (v === CAMPER_TYPES_INTEGER.CAMPERVAN) {
        return 0.5
      }

      return v
    }
    return options.slice().sort((a, b) => {
      return getOrderedValue(a.value) - getOrderedValue(b.value)
    })
  })

  return {
    vehicleOptions,
  }
}
